import { DataBean } from "../DataBean";

export class StatesCatalog extends DataBean {



    public async deleteStates(idStates: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteStates_Number", [idStates]);
    }

    public async getStatesCatalog(idCountries: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getStatesCatalog_Number_String_Number_Number", [idCountries, regexStr, page, recordsPerPage]);
    }

}